module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("确认信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "参赛人数",
      "value": _vm.sai_member_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "随行人数",
      "value": _vm.sui_member_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿缴费人数",
      "value": _vm.orderData.count
    }
  }), _vm._v(" "), _vm._l((_vm.orderData.list), function(room, rindex) {
    return _c('van-cell', {
      key: rindex,
      attrs: {
        "input-align": "right",
        "title": room.name,
        "value": room.count
      }
    }, [_c('van-stepper', {
      attrs: {
        "integer": "",
        "min": 0
      },
      on: {
        "change": _vm.countChange
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1)
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿费用",
      "value": _vm.orderData.price + '元'
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f29866b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep4Admin.vue
// module id = 2265
// module chunks = 0